import { Injectable } from "@angular/core";
import { MatSnackBar, MatSnackBarHorizontalPosition, MatSnackBarVerticalPosition } from "@angular/material/snack-bar";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: 'root',
})
export class CommonService {
    emailSubject = new BehaviorSubject<string | null>(null);
    constructor(private snackBar: MatSnackBar) { }
    openSnackBar(message: string, action: string, duration = 5000, panelClass: string | string[] = 'info-snackbar', verticalPosition?: MatSnackBarVerticalPosition, horizontalPosition?: MatSnackBarHorizontalPosition) {
        return this.snackBar.open(message, action, {
            duration,
            verticalPosition,
            horizontalPosition,
            panelClass
        });
    }

    setEmail(email: string) {
        localStorage.setItem('email', email);
        console.log("---localStorage-get email--", email);
        this.emailSubject.next(email);
    }

    getEmail(): string | null {
        return localStorage.getItem('email');
    }

}